import { State, useStore } from 'store';

import IAsync from 'types/IAsync';
import IEnvironment from 'types/IEnvironment';

export default function useEnvironmentsAsync(): IAsync<IEnvironment[]> {
  const environmentsAsync = useStore((state: State) => state.environmentsAsync);

  return environmentsAsync;
}
